import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',

    [theme.breakpoints.up('md')]: {
      position: 'absolute',
      top: '0',
      right: '0',
      height: '80%'
    }
  },

  taskModal: {
    display: 'flex',
    alignItems: 'center',

    [theme.breakpoints.up('md')]: {
      paddingTop: 6,
      alignSelf: 'flex-start'
    }
  },

  font: {
    fontSize: theme.size.sm
  },

  goto: {
    marginRight: '12px',
    color: theme.palette.primary.main,
    cursor: 'pointer'
  },

  button: {
    padding: '8px 12px',
    marginLeft: '0.5rem',
    width: 'auto',

    '& .icon': {
      marginRight: '0.5rem'
    }
  },

  endButton: {
    marginLeft: '0.5rem'
  },

  name: {
    '& span': {
      marginRight: '0.125rem',
      opacity: '0.35'
    }
  }
}))

export default useStyles
